export default __webpack_public_path__ + "static/media/Tomy.f0ee3b1b.png";